var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('v-alert',{staticClass:"flex-grow-1 text-caption text-sm-body-1 pt-1 mt-4 pt-sm-2",attrs:{"id":"section-alert","type":"info","prominent":"","color":"red darken-4"}},[(_vm.text1)?_c('div',{domProps:{"textContent":_vm._s(_vm.text1)}}):_vm._e(),(_vm.text2)?_c('div',{domProps:{"textContent":_vm._s(_vm.text2)}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }